import {h, Fragment} from "preact"
// export default function RangeInput({ className, ...props }) {
//     return <input type="number" className={`ns-input-field ns-d-block ${className}`} {...props} />
// }


export default function RangeInput({
    className,
    id,
    min,
    max,
    value,
    onChange,
    ...props
}) {
    // Format value for display (use empty string if undefined/null)
    // Round the value for display consistency if needed, but keep underlying state precise
    const displayValue = (value !== undefined && value !== null) ? String(Math.round(value)) : '';

    // Determine placeholder based on min/max props
    const placeholderValue = id.includes('min')
        ? (min !== undefined ? String(Math.round(min)) : '')
        : (max !== undefined ? String(Math.round(max)) : '');

    return (
        // Container includes the border and padding
        <div class="ns-custom-range-input-container">
            <input
                id={id}
                type="number" // Use number for better semantics and mobile keyboards
                inputmode="numeric" // Hint for numeric keyboard
                class="ns-custom-range-input"
                className={`ns-input-field ns-d-block ${className}`} 
                // Set min/max attributes for browser validation (use rounded values)
                // min={min !== undefined ? Math.round(min) : undefined}
                // max={max !== undefined ? Math.round(max) : undefined}
                value={displayValue}
                onChange={onChange} // Event handler from props
                placeholder={placeholderValue} // Show original min/max as placeholder
                // step="1" // Assuming integer prices
                {...props}
            />
            {props?.currency && <span class="ns-range-currency">{props?.currency}</span>}
        </div>
    );
}